export default {
  default: {
    primary: '#2C89F1'
  },
  success: {
    primary: '#00DEB2'
  },
  danger: {
    primary: '#FF0057',
  },
  background: '#353535',
  text: '#E3E3E3',
  time: 7500,
  position: 'bottom',
  close: false
}
